import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  //isSignedIn: false,
  email: "",
  token: "",
  role: "qc",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, payload) {
      localStorage.setItem("isSignedIn", true);
      localStorage.setItem("email", payload.payload.email);
      state.email = payload.payload.email;
      state.token = payload.payload.token;
      state.role = payload.payload.role;
    },
    logout(state) {
      localStorage.clear();
      localStorage.setItem("isSignedIn", false);
      localStorage.setItem("authToken", null);
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
